import cx from 'classnames';
import { arrayOf, bool, func, number, shape, string } from 'prop-types';
import { campaignState } from '../../../utils/campaignState';
import ProductContainerCustomizations from '../SharedComponents/ProductContainer/ProductContainerCustomizations';
import CustomizeSidebar from './CustomizeSidebar/CustomizeSidebar';
import * as classNames from './CustomizePanel.module.css';

const NotExpiredOpenParticipant = (props) => {
  const {
    displaySidebar,
    isMobile,
    items,
    viewAll,
    initialDisplayAmount,
    isSelect,
    displayOrderSummary,
    getExtraChoiceCount,
    boxData,
    cartSum,
    userData,
    displayViewButton,
    displayUpsellCta,
    toggleViewAll,
    status,
    pageItems,
  } = props;

  const productGridWrapperClassName = cx({
    [classNames.productGridWrapperWithSidebar]: !isMobile && displaySidebar,
    [classNames.productGridWrapper]: !isMobile && !displaySidebar,
  });

  return (
    <div
      className={cx(classNames.panelContainer, {
        [classNames.mobile]: isMobile,
      })}
    >
      <div className={productGridWrapperClassName}>
        <ProductContainerCustomizations
          open={status === campaignState.OPEN}
          products={isMobile ? pageItems : items}
          viewAll={viewAll}
          initialDisplayAmount={initialDisplayAmount}
          isSelect={isSelect}
          isMobile={isMobile}
        />
      </div>
      {displaySidebar && (
        <CustomizeSidebar
          displayOrderSummary={displayOrderSummary}
          getExtraChoiceCount={getExtraChoiceCount}
          boxData={boxData}
          cartSum={cartSum}
          userData={userData}
          displayViewButton={displayViewButton}
          displayUpsellCta={displayUpsellCta}
          viewAll={viewAll}
          toggleViewAll={toggleViewAll}
        />
      )}
    </div>
  );
};

NotExpiredOpenParticipant.propTypes = {
  displaySidebar: bool.isRequired,
  isMobile: bool.isRequired,
  items: arrayOf(shape({})).isRequired,
  viewAll: bool.isRequired,
  initialDisplayAmount: number.isRequired,
  isSelect: bool.isRequired,
  displayOrderSummary: bool.isRequired,
  getExtraChoiceCount: func.isRequired,
  boxData: shape({}).isRequired,
  cartSum: number.isRequired,
  userData: shape({}).isRequired,
  displayViewButton: bool.isRequired,
  displayUpsellCta: bool.isRequired,
  toggleViewAll: func.isRequired,
  status: string.isRequired,
  pageItems: arrayOf(shape({})).isRequired,
};

export default NotExpiredOpenParticipant;
